require("typeface-work-sans");
require("typeface-kalam");
require("./src/components/css/layout.css");
require("./src/components/scripts.js");
